// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useMutation, useRequest } from "redux-query-react";
import { createSelector } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import * as QueryString from 'query-string';
import { isEqual } from "lodash";
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { PrivateBenchmarkIdentifierToJSON, PrivateBenchmarkResponseFromJSON, PrivateBenchmarkSummaryFromJSON, } from '../models';
/**
 * Excel exports selected private benchmarks
 * Export private benchmarks
 */
export function exportPrivateBenchmarksRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    queryParameters = {};
    if (requestParameters.lastQuarterOnly !== undefined) {
        queryParameters['lastQuarterOnly'] = requestParameters.lastQuarterOnly;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/privatebenchmarks/export` + queryString,
        meta,
        update: requestConfig.update,
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: requestParameters.privateBenchmarkIdentifier?.map(PrivateBenchmarkIdentifierToJSON),
        transform: requestConfig.transform
    };
    config.queryKey = requestConfig.queryKey || `ExportPrivateBenchmarks-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Excel exports selected private benchmarks
* Export private benchmarks
*/
export function exportPrivateBenchmarks(requestParameters, requestConfig) {
    return exportPrivateBenchmarksRaw(requestParameters, requestConfig);
}
/**
 * Get list of Private Benchmarks
 * Get all private benchmarks
 */
export function getPrivateBenchmarksRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    queryParameters = {};
    if (requestParameters.type !== undefined) {
        queryParameters['type'] = requestParameters.type;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    if (requestParameters.codes !== undefined) {
        queryParameters['codes'] = requestParameters.codes;
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    if (requestParameters.referenceDate !== undefined) {
        queryParameters['referenceDate'] = requestParameters.referenceDate.toISOString();
    }
    queryString = `?${QueryString.stringify(queryParameters)}`;
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/privatebenchmarks` + queryString,
        meta,
        update: requestConfig.update || {
            PrivateBenchmarks: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(PrivateBenchmarkResponseFromJSON);
            return {
                PrivateBenchmarks: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetPrivateBenchmarks-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Get list of Private Benchmarks
* Get all private benchmarks
*/
/**
 * Use this selectors to get a record of all Array<PrivateBenchmarkResponse>, with their ids as keys
 * @returns A record of Array<PrivateBenchmarkResponse> object, with their ids as keys
 */
export const usePrivateBenchmarksRecordSelector = () => useSelector((state) => state.entities.PrivateBenchmarks, isEqual);
const PrivateBenchmarksArraySelector = createSelector((state) => state.entities.PrivateBenchmarks, (selectedSubState) => Object.keys(selectedSubState).map((id) => selectedSubState[id]));
/**
 * Use this selector to get a reference to a flat Array<PrivateBenchmarkResponse>.
 * If you are doing transformation on this object, consider using usePrivateBenchmarksRecordSelector instead for performances
 * @returns An array containing all loaded PrivateBenchmarks
 */
export const usePrivateBenchmarksArraySelector = () => useSelector(PrivateBenchmarksArraySelector, isEqual);
/**
 * Request hook for Array<PrivateBenchmarkResponse>
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns an array containg the data, query status, and a call for refresh
 * (note : refresh shouldn't be necessary, update to the state should be handle by mutators)
 */
export const useGetPrivateBenchmarks = (requestParameters, customQueryConfig) => {
    const [querystate, forceRefresh] = useRequest(getPrivateBenchmarksRaw(requestParameters, customQueryConfig));
    return [
        usePrivateBenchmarksArraySelector(),
        querystate,
        forceRefresh
    ];
};
export function getPrivateBenchmarks(requestParameters, requestConfig) {
    return getPrivateBenchmarksRaw(requestParameters, requestConfig);
}
/**
 * Upload excel file with private benchmarks
 * Post custom private benchmark
 */
export function postCustomPrivateBenchmarksRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/octet-stream';
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/privatebenchmarks` + queryString,
        meta,
        update: requestConfig.update || {
            PrivateBenchmarks: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: requestParameters.body,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(PrivateBenchmarkSummaryFromJSON);
            return {
                PrivateBenchmarks: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `PostCustomPrivateBenchmarks-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Upload excel file with private benchmarks
* Post custom private benchmark
*/
/**
 * Mutation hook to create a Client
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to upsert an array client
 */
export const usePostCustomPrivateBenchmarks = (customQueryConfig) => {
    return useMutation((body, customQueryParam) => postCustomPrivateBenchmarksRaw({ body }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function postCustomPrivateBenchmarks(requestParameters, requestConfig) {
    return postCustomPrivateBenchmarksRaw(requestParameters, requestConfig);
}
